var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner"},[_c('el-carousel',{attrs:{"interval":5000,"arrow":"always"}},_vm._l((_vm.bannerList),function(item,index){return _c('el-carousel-item',{key:index},[_c('img',{staticClass:"banner-img",attrs:{"src":item.imgSrc,"alt":""}})])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }